import { useNavigate } from "react-router-dom";
import Button from "../../../views/buttons/Button";
import SaveButton from "../../../views/buttons/Button";
import Event from "../../assests/img/event.png";
import SlidingPane from "react-sliding-pane";
import AddEventSlider from "./AddEventSlider";
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CATCH_MESSAGE, getImage } from "../../../UtilityFunctions";
import wbApi from "../../../API/wbApi";
import { updateEventsArr, updateStateAfterNewEventAdded } from "../../../redux/actions/EventsAction";
import { nanoid } from "@reduxjs/toolkit";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import { useEffect, useState } from "react";
import { ShowConfirmationPrompt, CancelConfirmationPrompt } from "../../../redux/actions/PromptAction";

const CreatedEvent = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { defaultSectionId } = useSelector(
    (state: RootState) => state.sections
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);

  const data = useSelector(
    (state: RootState) => state.eventsSect
  );

  const dispatch = useDispatch()

  const [allSelectedEvents, setAllSelectedEvents] = useState<any>([]);
  const [defaultValue, setDefaultValue] = useState<any>({})

  const selectEvents = () => {
    setAllSelectedEvents([...data.eventsArr.filter((obj: any) => {
      if (obj.hotel_id === data.hotel_id) return obj
    })])
  }

  useEffect(() => {
    if (!data.hotel_id) return
    selectEvents()
  }, [data])


  const getEventsDataApi = async () => {
    try {
      const resp = await wbApi.get(
        `wb-dashboard/fetch-wb-event-section-details/${company_id}/${template_id}/${defaultSectionId}`
      );
      if (resp.data.status === 1) {
        setDefaultValue(resp.data.default_hotel)
      } else {
        setDefaultValue({})
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };

  useEffect(() => {
    getEventsDataApi();
  }, []);


  const deleteSelectedEvent = async (ID: any) => {
    dispatch(
      ShowConfirmationPrompt(
        `Are you sure want to delete this ?`,
        "DELETE",
        async () => {
          try {
            const payload = { company_id, template_id, id: ID }
            const resp = await wbApi.post(`wb/delete-wb-event`, payload)

            if (resp.data.status === 1) {
              toast.success(resp.data.message)
              dispatch(updateStateAfterNewEventAdded(nanoid()))

              const getResp = await wbApi.get(`wb-dashboard/fetch-wb-event-section-details/${company_id}/${template_id}/13`)
              dispatch(updateEventsArr(getResp.data.hotel_events))
            }
            else {
              toast.error(resp.data.message)
            }
          }
          catch {
            toast.error(CATCH_MESSAGE)
          }

          dispatch(CancelConfirmationPrompt());
        }
      )
    );

  }
  const makeDefaultHotel = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      let response = await wbApi.post(`/wb/make-hotel-default-for-section`, {
        id: defaultValue?.id ?? "undefined",
        company_id: company_id,
        template_id: template_id,
        default_hotel_id: event.target.checked === true ? data.hotel_id : "",
        section_id: defaultSectionId
      })
      if (response.data.status === 1) {
        toast.success(response.data.message);
        getEventsDataApi();
      } else {
        toast.error(response.data.message);
      }

    } catch (error) {
      toast.error(CATCH_MESSAGE);

    }
  }




  return (
    <>
      <div className="wb-subheader">
        <CustomBreadcrumbs
          content={[
            {
              label: "Sections",
              href: "/section-default",
            },
            {
              label: `Default Section`,
              href: "/section-default",
            },
            {
              label: " Edit Event",
              href: "/section-default/edit-nearbyplaces"
            },
            {
              label: `${data.hotel_name ? data.hotel_name : ''}`
            }
          ]}
        />
        <div className="wb-subheader-rightsec">
          <Button
            icon="bi bi-arrow-left"
            className="bck-btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Back
          </Button>
        </div>
      </div>

      <div className="wb-divider"></div>

      <div className="top__button__container">
        <div className="form-check default_label me-2">
          <label className="form-check-label mt-2" htmlFor="setDefault">
            Set as Default
          </label>
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="setDefault"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => makeDefaultHotel(e)}
            checked={defaultValue?.default_hotel_id == data.hotel_id}
          ></input>
        </div>
        <Button
          icon="bi bi-info-circle"
          className="me-3"
          handleClick={() => {
            setOpen(true);
          }}
        >
          Add Event
        </Button>
      </div>

      <div className="default_section_image_card_container mt-3">
        {
          allSelectedEvents.map((obj: any, idx: number) => {
            const { id, hotel_id, event_title, event_image_id, event_image_alt, event_image, event_description, event_date, display_description } = obj


            return (
              <div className="default__setion__image" style={{ marginRight: '20px', flexBasis: '23%' }} key={idx}>
                <div className="image__container" style={{ minHeight: "120px" }}>
                  <img src={getImage(event_image)} />
                  <div className="overlay overlay-border-radius">
                    <div className="button__container">
                      <div
                        className="edit-button"
                        onClick={() => {
                          navigate(`edit-individual-event/${id}`, {
                            state: {
                              event_title: event_title
                            }
                          });
                        }}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </div>
                      <div className="delete-button" onClick={() => { deleteSelectedEvent(id) }}>
                        <i className="bi bi-trash"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hotel__name">{event_title}</div>
              </div>
            )
          })
        }
      </div>


      <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={open}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setOpen(false)}
      >
        <AddEventSlider
          onClose={() => {
            setOpen(false);
          }}
        />
      </SlidingPane>
    </>
  );
};

export default CreatedEvent;
